<template>
  <div class="hamburger-demo-menubox">
    <input id="hamburger-demo1" type="checkbox" class="input-hidden" />
    <label
      for="hamburger-demo1"
      class="hamburger-demo-switch hamburger-demo-switch1"
    >
      <span class="hamburger-switch-line1"></span>
    </label>
    <div class="hamburger-demo-menuwrap">
      <div class="clear">
        <!--マイカード-->
        <div class="member_card" v-if="isAuthenticated">
          <div class="mc01">
            <div class="left01">
              <p v-if="!isYagiPrime && !isYagiPrimeCancel">
                会員：
                <a
                  href="/yagiprime_register"
                  id="prime-mypagetop-btn"
                  class="status"
                >
                  一般会員（アップグレード）
                </a>
              </p>
              <p v-else-if="isYagiPrime && isYagiPrimeCancel">
                会員：
                <a href="/mypage/yagiprime" class="status">
                  一般会員（ヤギプライム解約手続き済）
                </a>
              </p>
              <p v-else>
                会員：
                <a href="/mypage/yagiprime" class="status">
                  ヤギプライム会員
                </a>
              </p>

              <p class="name">
                名前：
                <span v-if="userName">{{ userName }} </span>
                <span v-else>{{ userEmail }}</span>
              </p>

              <p class="yagidy" v-if="digramResult">
                ヤギ：
                <span>{{ digramResult.detail_value.catch_copy_title }}</span>
              </p>
              <p class="yagidy" v-else>
                ヤギ：
                <a href="/yagidigram/">あなたのヤギは？</a>
              </p>

              <p class="u-mail">
                <span>{{ userEmail }}</span>
              </p>
            </div>
          </div>
          <div class="mc02">
            <a href="/mypage" class="mp-link">マイページ</a>
          </div>
        </div>
        <div class="member_card" style="height: auto" v-else>
          <p style="text-align: center; font-weight: bold">
            ＼無料で会員登録／
          </p>
          <div class="mc02">
            <a href="/login" class="mp-link">ログイン・会員登録</a>
          </div>
        </div>

        <!--サービスリンク-->
        <div class="servicelink">
          <div class="renew2_flex renew2_sp_flex servicelink-item">
            <h4 class="sl-h4">つくる</h4>
            <ul class="sl-list">
              <li>
                <a href="/format/rirekisho_job_change" class="sl-link"
                  >履歴書</a
                >
              </li>
              <li>
                <a href="/static/ocr/" class="sl-link">履歴書を読み取る(OCR)</a>
              </li>
              <li>
                <a href="/format/shokumukeirekisho" class="sl-link"
                  >職務経歴書</a
                >
              </li>
              <li>
                <a href="/format/letter" class="sl-link">送付状</a>
              </li>
              <li>
                <a
                  href="#"
                  class="sl-link"
                  @click.prevent="openTemplateApp('sp_menu')"
                  >請求書・見積書</a
                >
              </li>
            </ul>
          </div>
          <div class="renew2_flex renew2_sp_flex servicelink-item">
            <h4 class="sl-h4">サービス</h4>
            <ul class="sl-list">
              <li>
                <a href="/servicelist" class="sl-link">サービス一覧を見る</a>
              </li>

              <li v-if="isAuthenticated">
                <a href="/mypage/yagioffer" class="sl-link"
                  >オファーを確認する</a
                >
              </li>
              <li v-else>
                <a
                  style="line-height: 1.4"
                  href="/format/rirekisho_job_change"
                  class="sl-link"
                  >オファーを受け取る<br />（履歴書作成）</a
                >
              </li>

              <li v-if="isAuthenticated">
                <a href="/mypage/yagiprime" class="sl-link">AIを使ってみる</a>
              </li>
              <li v-else>
                <a href="/yagiprimeinfo" class="sl-link">ヤギプライム</a>
              </li>

              <li>
                <a href="/yagidigram" class="sl-link">ヤギディ診断する</a>
              </li>
            </ul>
          </div>
        </div>

        <!--各種リンク-->
        <div class="otherlink">
          <ul class="renew2_sp_flex ol-item">
            <li class="ol-list">
              <a href="/help" target="_blank" class="ol-link">よくある質問</a>
            </li>
            <li class="ol-list">
              <a href="/info" target="_blank" class="ol-link">使いかた</a>
            </li>
            <li class="ol-list">
              <a href="/terms" target="_blank" class="ol-link">利用規約</a>
            </li>
            <li class="ol-list">
              <a
                href="https://www.yagish.jp/privacy/"
                target="_blank"
                class="ol-link"
                >個人情報保護方針</a
              >
            </li>
            <li class="ol-list">
              <a
                href="https://www.yagish.jp/company/"
                target="_blank"
                class="ol-link"
                >運営会社について</a
              >
            </li>
            <li class="ol-list">
              <a
                href="/contact"
                target="_blank"
                rel="noopener noreferrer"
                class="ol-link"
                >お問い合わせ</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="hamburger-demo-cover"></div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useAuth } from '@/composables/useAuth'
import { useTemplateApp } from '@/composables/useTemplateApp'

withDefaults(
  defineProps<{
    isYagiPrime?: boolean
    isYagiPrimeCancel?: boolean
  }>(),
  {
    isYagiPrime: false,
    isYagiPrimeCancel: false
  }
)

const { user, isAuthenticated } = useAuth()
const { open: openTemplateApp } = useTemplateApp()

const userEmail = computed(() => user.value?.email ?? '')

/** 移設元 App.vue の getName 相当 */
const userName = computed(() => {
  const displayName = user.value?.displayName
  if (displayName) return displayName
  const email = userEmail.value
  return email ? email.split('@')[0] : 'ヤギ'
})

/**
 * ヤギディ診断結果。移設元でも値を入れる経路が無く常に null のため、
 * 「あなたのヤギは？」導線だけが出る（挙動そのまま）。
 */
const digramResult = ref<{
  detail_value: { catch_copy_title: string }
} | null>(null)
</script>

<style lang="scss" scoped>
/* hamburgerここから */

/* inputを非表示 */
.input-hidden {
  display: none;
}

/* label */
.hamburger-demo-switch {
  cursor: pointer;
  position: absolute;
  right: 12px;
  top: 0;
  z-index: 3;
  width: 35px;
  height: 35px;
}

/* メニュー展開時にハンバーガーアイコンを固定 */
#hamburger-demo1:checked ~ .hamburger-demo-switch {
  position: fixed;
  top: 10px;
}

/* ハンバーガーアイコン */
.hamburger-switch-line1,
.hamburger-switch-line1::before,
.hamburger-switch-line1::after {
  width: 25px;
  height: 3px;
  background: #004d40;
  border-radius: 5px;
  position: absolute;
  top: 50%;
  left: 50%;
  transition: 0.3s;
  content: '';
}

.hamburger-switch-line1 {
  transform: translate(-50%, -50%);
}

.hamburger-switch-line1::before {
  transform: translate(-50%, -300%);
}

.hamburger-switch-line1::after {
  transform: translate(-50%, 200%);
}

/* ハンバーガーアイコン･アニメーション */
#hamburger-demo1:checked ~ .hamburger-demo-switch .hamburger-switch-line1 {
  width: 0;
}

#hamburger-demo1:checked
  ~ .hamburger-demo-switch
  .hamburger-switch-line1::before {
  transform: rotate(45deg) translate(-40%, 325%);
}

#hamburger-demo1:checked
  ~ .hamburger-demo-switch
  .hamburger-switch-line1::after {
  transform: rotate(-45deg) translate(-40%, -325%);
}

/* メニューエリア */
.hamburger-demo-menuwrap {
  position: fixed;
  height: 100%;
  background: #fafafa;

  /* メニューエリアの背景色 */
  padding: 3.5em 3% 2em;
  z-index: 2;
  transition: 0.3s;
  overflow-y: scroll;

  /* メニュー内容が多い場合に縦スクロールする */
  top: 0;
  left: 100%;
  width: 90%;

  .clear {
    .member_card {
      background: #8fbd67;
      color: #fff;
      border-radius: 10px;
      padding: 20px;
      margin-bottom: 20px;

      .mc01 {
        align-items: center;

        .left01 {
          margin-bottom: 15px;
          color: #fff;
          font-weight: bold;
          font-size: 14px;

          .status {
            color: #fff;
          }
        }
      }
    }

    .servicelink {
      margin-bottom: 20px;

      .servicelink-item {
        justify-content: space-between;
        padding: 20px;
        border-bottom: 1px solid #dfdfdf;

        &:first-child {
          padding: 0 20px 20px;
        }

        .sl-h4 {
          color: #0f9934;
          font-size: 14px;
          line-height: 2.2;
        }

        .sl-list {
          width: calc(100% - 80px);
          line-height: 2.2;

          .sl-link {
            position: relative;
            display: block;
            width: 100%;

            &::after {
              content: '';
              width: 7px;
              height: 7px;
              border: 0;
              border-bottom: 2px solid #0f9934;
              border-right: 2px solid #0f9934;
              transform: rotate(-45deg);
              position: absolute;
              top: 0;
              right: 15px;
              bottom: 0;
              margin: auto;
            }
          }
        }
      }
    }

    .otherlink {
      .ol-item {
        flex-wrap: wrap;

        .ol-list {
          width: calc(50% - 10px);
          font-size: 12px;
          margin: 4px;
        }
      }
    }

    .mp-link {
      position: relative;
      display: block;
      width: 100%;
      text-align: center;
      padding: 5px 0;
      font-weight: bold;
      color: #fff;
      font-size: 14px;
      background: #0f9934;
      border-radius: 10px;

      &::after {
        content: '';
        width: 7px;
        height: 7px;
        border: 0;
        border-bottom: 2px solid #fff;
        border-right: 2px solid #fff;
        transform: rotate(-45deg);
        position: absolute;
        top: 0;
        right: 15px;
        bottom: 0;
        margin: auto;
      }

      &:hover {
        opacity: 1;
        text-decoration: none;
      }
    }
  }
}

/* メニューエリア･アニメーション */

/* 右から */
#hamburger-demo1:checked ~ .hamburger-demo-menuwrap {
  left: 10%;
}

/* コンテンツカバー */
#hamburger-demo1:checked ~ .hamburger-demo-cover {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  background: rgb(3 3 3 / 50%);
  display: block;
}
</style>
